import { render, staticRenderFns } from "./SlidingTab.vue?vue&type=template&id=42af4a14&scoped=true"
import script from "./SlidingTab.vue?vue&type=script&lang=js"
export * from "./SlidingTab.vue?vue&type=script&lang=js"
import style0 from "./SlidingTab.vue?vue&type=style&index=0&id=42af4a14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42af4a14",
  null
  
)

export default component.exports